angular.module('impactx.disposition').controller('DispositionListCtrl', [
    'selectedListItems',
    DispositionListCtrl
]);

function DispositionListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'Disposition'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/disposition/templates/dispositionlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/disposition/list',
        ctrl: this,
        id: "disposition",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "dispositiondetail/" + selectedListItems.getFirstSelectedId();
    }

}
